import React from "react";

const VehicleCard = ({ insurance }) => {
  const ticket = insurance.ticket_id || {};
  const vehicle = insurance.vehicle_id || {};
  const driver = insurance.driver_id || {};
  const supervisor = insurance.supervisor_id || {};

  return (
    <div className="vehicle-info-wrapper">

      {/* =================================
          VEHICLE INFORMATION
      ================================= */}
      <div className="section-card vehicle-information-card">

        <div className="section-title">
          Vehicle Information
        </div>

        <div className="vehicle-info-grid">

          {/* Vehicle Number */}
          <div className="info-item">
            <label>Vehicle Number</label>
            <span>
              {ticket.vehicle_number || "-"}
            </span>
          </div>

          {/* Vehicle Type */}
          <div className="info-item">
            <label>Vehicle Type</label>
            <span>
              {vehicle.id_type?.vehiclename || "-"}
            </span>
          </div>

          {/* Company */}
          <div className="info-item">
            <label>Company</label>
            <span>
              {vehicle.id_type?.company || "-"}
            </span>
          </div>

          {/* Odometer */}
          <div className="info-item">
            <label>Odometer</label>
            <span>
              {ticket.vehicle_odometer || "-"}
            </span>
          </div>

          {/* Driver */}
          <div className="info-item">
            <label>Driver</label>
            <span>
              {driver.name || "-"}
            </span>
          </div>

          {/* Driver Phone */}
          <div className="info-item">
            <label>Driver Phone</label>
            <span>
              {driver.phonenumber || "-"}
            </span>
          </div>

          {/* Supervisor */}
          <div className="info-item">
            <label>Supervisor</label>
            <span>
              {supervisor.name || "-"}
            </span>
          </div>

        </div>
      </div>


      {/* =================================
          ISSUE DETAILS
      ================================= */}
      <div className="section-card issue-description-card">

        <div className="section-title">
          Issue Details
        </div>

        <div className="issue-grid">

          {/* Issue */}
          <div className="info-item issue-item">
            <label>Issue</label>
            <span>
              {ticket.heading || "-"}
            </span>
          </div>


          {/* Status */}
          <div className="info-item status-item">
            <label>Status</label>

            <span className="status-value">
              {insurance.status || "-"}
            </span>
          </div>


          {/* Description */}
          <div className="info-item description-item">
            <label>Description</label>

            <span>
              {ticket.description || "-"}
            </span>
          </div>

        </div>
      </div>

    </div>
  );
};

export default VehicleCard;